<template>
  <div class="flex h-full flex-col">
    <slot />
  </div>
</template>
